import { Color, Vector3 } from 'three';
import { Box3 } from 'three/src/math/Box3';
import { Easing, Tween, update } from '@tweenjs/tween.js';

export const tweenValueTo = <T extends { [key: string]: any }>(
    object: T,
    value: T[keyof T],
    duration: number,
    delay = 0
) => {
    function animate() {
        const animationFrameId = requestAnimationFrame(animate);
        const result = update();
        if (!result) {
            cancelAnimationFrame(animationFrameId);
        }
    }
    new Tween(object)
        .to(value, duration)
        .easing(Easing.Cubic.InOut)
        .delay(delay)
        .start();
    animate();
};

export const getPositionFromBoundingBox = (bbox: Box3, scale = 1, offset = new Vector3(0, 0, 0)) =>
    new Vector3(
        ((bbox.max.x + bbox.min.x) / 2) * scale + offset.x,
        ((bbox.max.y + bbox.min.y) / 2) * scale + offset.y,
        ((bbox.max.z + bbox.min.z) / 2) * scale
    );

export const getBoardAssetPosition = (position: Box3 | Vector3, scale = 0.25, offset = new Vector3(0, 0, 0)) => {
    const { x, y, z } =
        position instanceof Box3
            ? { x: position.max.x, y: position.max.y, z: position.max.z }
            : { x: position.x, y: position.y, z: position.z };

    const { xMin, yMin, zMin } =
        position instanceof Box3
            ? { xMin: position.min.x, yMin: position.min.y, zMin: position.min.z }
            : { xMin: position.x, yMin: position.y, zMin: 0 };

    return new Vector3(
        ((x + xMin) / 2) * scale + offset.x,
        ((y + yMin) / 2) * scale + offset.y,
        ((z + zMin) / 2) * scale
    );
};

export const getColor = (color: string) => new Color(parseInt(color.replace('#', '0x'), 16));
